import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { documentTypesAPI } from '../redux/document-type.slice';

export function useDocumentType(id: string | null | undefined) {
  const { entity: documentType } = useEntityIdSelector(documentTypesAPI, id);
  return { documentType };
}
